
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M501.602 106.85c-2.301-.899-4.5-1.3-6.602-1.3-4.699 0-8.699 1.7-11.898 5L376.9 216.65v-43.5c0-20.9-7.4-38.801-22.299-53.7-14.801-14.9-32.701-22.3-53.602-22.3H115.501c-20.9 0-38.8 7.399-53.6 22.3-14.8 14.899-22.3 32.8-22.3 53.7v185.7c0 20.9 7.4 38.801 22.3 53.699 14.9 14.9 32.7 22.301 53.6 22.301h185.601c20.898 0 38.799-7.4 53.6-22.301C369.5 397.65 377 379.75 377 358.85v-43.801L483.201 421.35c3.199 3.301 7.1 5 11.9 5 2.1 0 4.299-.4 6.6-1.301 6.9-3 10.299-8.199 10.299-15.6V122.45c-.1-7.4-3.5-12.6-10.398-15.6z"}})])
          )
        }
      }
    